export const inventoryTableSx = {
  flex: "none",
  height: "min(350px, 60dvh)",
};
